import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, onAuthStateChanged, signOut } from './utils/firebase';
import api from './utils/api';

const AuthContext = createContext({ user: null, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
      if (u) {
        api.post('/activity', {
          type: 'user_login',
          title: 'User logged in',
          description: 'Signed-in session started'
        }).catch(error => console.error('Failed to record user login:', error));
      }
    });
    return () => unsub();
  }, []);

  const value = { user, loading, signOut: () => signOut(auth) };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
